import { debugFactory } from '@iva/debugger';
const DEBUG_CONFIG = {
    name: 'syncidentity',
    bColor: '#ee82ee',
    fColor: '#fff',
};
export const STATES = {
    START: 'start',
    DONE: 'done',
    ERROR: 'error',
};
// Use URL parameter ?sznivadbg=1 or ?sznivadbg=syncidentity for debugging
export const syncidsDebug = debugFactory(DEBUG_CONFIG);
